import { useAuth, useClerk } from '@clerk/clerk-react';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { Menu, Top } from '~/components/Navigation';
import useAuthentication from '~/hooks/use-authentication';
import useClipboard from '~/hooks/use-clipboard';
import useOrganizations from '~/hooks/use-organizations';
import useStatuspage from '~/hooks/use-statuspage';
import useThemePicker from '~/hooks/use-theme-picker';

function Navigation() {
  const clipboard = useClipboard();
  const { getToken } = useAuth();
  const { openUserProfile } = useClerk();
  const { theme: currentTheme, switchTheme } = useThemePicker();
  const location = useLocation();
  const {
    email,
    isOrgMember,
    isOwner,
    isDemiGod,
    isGod,
    assumeOrganizationId,
    assumedOrganizationId,
    toggleIsViewingAsAssumedOrganization,
    isViewingAsAssumedOrganization,
    usersOrganizations,
    usersCurrentOrganizationId,
    changeOrganization,
  } = useAuthentication();
  const status = useStatuspage();
  const organizations = useOrganizations();
  const { isOrgGod } = organizations;

  return (
    <>
      <Top
        clipboard={clipboard}
        theme={{ currentTheme, switchTheme }}
        clerk={{ getToken, openUserProfile }}
        userInfo={{
          email,
          isOrgMember,
          isOwner,
          isDemiGod,
          isGod,
          assumeOrganizationId,
          assumedOrganizationId,
          toggleIsViewingAsAssumedOrganization,
          isViewingAsAssumedOrganization,
          usersOrganizations,
          usersCurrentOrganizationId,
          changeOrganization,
        }}
        status={status}
        organizations={organizations}
      />
      <Menu
        location={location}
        userInfo={{ isOrgMember, isOwner, isGod, isOrgGod }}
      />
    </>
  );
}

export default Navigation;
